'use strict';

module.exports = class extends Backbone.View {
  initialize() {
    var _this = this;

    this.$form = $('.app-download-widget-form');

    if (!this.$form.length) {
      return;
    }

    this.appDownloadWidgetForm = this.$form[0];
    this.phoneInput = this.appDownloadWidgetForm.querySelector('.phoneMasked');
    this.submitButton = this.appDownloadWidgetForm.querySelector('.app-download-widget-send-link-button');
    this.errorMessage = this.appDownloadWidgetForm.querySelector('.app-download-widget-error-message');

    this.successMessage = document.querySelector('.app-download-widget-success-message');

    this.appDownloadWidgetForm.addEventListener('submit', function (e) {
      _this.onButtonClickHandler(e);
    }, false);

    this.phoneInput.addEventListener('input', function (e) {
      var x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    });

    this.successMessage.querySelector('a').addEventListener('click', function () {
      _this.phoneInput.value = '';
      _this.$form.show();
      _this.successMessage.classList.add('is-hidden');
    });
  }

  onButtonClickHandler(e) {
    if (this.isFormValid()) {
      this.sendSms();
    } else {
      this.onFailure();
    }

    e.preventDefault();
  }

  isFormValid() {
    var phoneNumber = this.phoneInput.value.replace(/[^\d]/g, '');
    return phoneNumber.length === 10 && !isNaN(phoneNumber)
  }

  sendSms() {
    var _this = this;

    var data = this.$form.serialize() + '&grpn_dl=desktop_home_sms';

    $.ajax({
      beforeSend: function () {
        _this.disableSubmitButton();
      },
      complete: function () {
        _this.enableSubmitButton();
      },
      type: 'POST',
      data: data,
      dataType: 'json',
      url: '/mobile/send_sms_message',
      success(data) {
        if (data && data.status && (data.status === 'failure')) {
          _this.onFailure();
        } else {
          _this.onSuccess();
        }
      },
      error() {
        _this.onFailure();
      }
    });
  }

  onSuccess() {
    this.$form.hide();
    this.successMessage.classList.remove('is-hidden');
    this.hideErrorMessage();
  }

  onFailure() {
    this.showErrorMessage(window.I18n.translate('js.modules.app_download_widget.errorMessage'));
  }

  enableSubmitButton() {
    this.submitButton.setAttribute('value', window.I18n.translate('js.modules.app_download_widget.buttonText'));
    this.submitButton.disabled = false;
  };

  disableSubmitButton() {
    this.submitButton.setAttribute('value', window.I18n.translate('js.modules.app_download_widget.buttonTextSending'));
    this.submitButton.disabled = true;
  }

  showErrorMessage(message) {
    this.errorMessage.innerHTML = message;
    this.errorMessage.classList.remove('is-hidden');
    this.phoneInput.classList.add('error');
  };

  hideErrorMessage() {
    this.errorMessage.innerHTML = '';
    this.errorMessage.classList.add('is-hidden');
    this.phoneInput.classList.remove('error');
  };
};
